import { render } from "./PageResetPassword.vue?vue&type=template&id=74e6ac8a"
import script from "./PageResetPassword.vue?vue&type=script&lang=js"
export * from "./PageResetPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__